/**
 * Cart Upsell Carousel
 * - Variant select: updates hidden input + displayed price
 * - Add-to-cart animation: triggers the checkmark burst on submit
 * - Prevents slideshow drag from blocking interactive elements (select, button)
 * Carousel behaviour is handled by the theme's native slideshow-component;
 * this file re-initializes it after cart updates (see bottom of file).
 */

/*
 * Stop mousedown from reaching the slideshow's drag handler
 * on interactive elements. The slideshow calls event.preventDefault()
 * on all mousedowns which blocks native <select> from opening.
 */
document.addEventListener(
  'mousedown',
  (e) => {
    if (e.target.closest('.mp-cart-upsell__card select, .mp-cart-upsell__card button, .mp-cart-upsell__card a')) {
      e.stopPropagation();
    }
  },
  true
);

/* Variant select */
document.addEventListener('change', (e) => {
  const select = e.target.closest('[data-upsell-variant-select]');
  if (!select) return;

  const card = select.closest('.mp-cart-upsell__card');
  if (!card) return;

  const selectedOption = select.options[select.selectedIndex];
  const variantInput = card.querySelector('input[name="id"]');
  const priceDisplay = card.querySelector('[data-upsell-price-display]');

  if (variantInput) {
    variantInput.value = select.value;
  }

  if (priceDisplay && selectedOption) {
    priceDisplay.textContent = selectedOption.dataset.price;
  }
});

/* Add-to-cart animation on submit */
document.addEventListener('submit', (e) => {
  const card = e.target.closest('.mp-cart-upsell__card');
  if (!card) return;

  const btn = card.querySelector('.mp-cart-upsell__add-btn');
  if (!btn || btn.dataset.added === 'true') return;

  btn.dataset.added = 'true';
});

/*
 * Re-initialize the upsell carousel after cart updates (MeshPlanet).
 * Horizon's slideshow-component only sets itself up in connectedCallback
 * (scroller, drag, slide count). Cart updates morph the drawer in place, so
 * slides get added/removed without the component re-running its setup, and
 * the carousel stops swiping until a page reload. Moving the element to the
 * same position fires disconnectedCallback (cleanup) + connectedCallback
 * (fresh setup with the current slides).
 */
const UPSELL_SLIDESHOW = '.mp-cart-upsell slideshow-component';

/** Slide count each upsell slideshow was last initialized with */
const initializedSlideCounts = new WeakMap();

const getSlideCount = (slideshow) => slideshow.querySelectorAll('slideshow-slide').length;

const reinitializeSlideshow = (slideshow) => {
  const parent = slideshow.parentNode;
  if (!parent) return;
  parent.insertBefore(slideshow, slideshow.nextSibling);
};

let syncScheduled = false;

const syncUpsellSlideshows = () => {
  syncScheduled = false;

  for (const slideshow of document.querySelectorAll(UPSELL_SLIDESHOW)) {
    const slideCount = getSlideCount(slideshow);
    if (initializedSlideCounts.get(slideshow) === slideCount) continue;

    // New (inserted by morph) or slide count changed: run the setup again
    initializedSlideCounts.set(slideshow, slideCount);
    reinitializeSlideshow(slideshow);
  }
};

// Slideshows present on page load were set up with their final slides already
for (const slideshow of document.querySelectorAll(UPSELL_SLIDESHOW)) {
  initializedSlideCounts.set(slideshow, getSlideCount(slideshow));
}

// Batch morph mutations into one check per frame (cheap: one querySelectorAll)
const upsellObserver = new MutationObserver(() => {
  if (syncScheduled) return;
  syncScheduled = true;
  requestAnimationFrame(syncUpsellSlideshows);
});

for (const cartItems of document.querySelectorAll('cart-items-component')) {
  upsellObserver.observe(cartItems, { childList: true, subtree: true });
}
